import { YupSchema } from 'services/yup/types'
import { yupArray, yupIgnore, yupNumber, yupString } from 'services/yup'
import { experienceVS } from './experience'
import { APIPriceRange } from 'services/api/entities/catalog/types'
import { PhysicalExperience } from 'services/api/entities/catalog/physical/types/internal/physical-models'

export const physicalVS: YupSchema<
  PhysicalExperience,
  APIPriceRange[] | undefined
> = experienceVS.shape({
  minDuration: yupNumber().required(),
  maxDuration: yupNumber().required(),
  fullAddress: yupString(),
  settingFacets: yupArray(),
  teambuildingCategoryFacet: yupIgnore(),
  languageFacets: yupArray(),
})
